/** 列出陣列元素並以符號間隔。*/
export const rowComponents = (data: string[], seprator?: string) => {
  return data.map((item, index) => {
    index += 1;
    return index !== data.length ? item + seprator : item;
  });
};

/** 日期計算增加日數。 */
export const addDate = (date: Date, days: number) => {
  date.setDate(date.getDate() + days);
  return date;
};

/** 設置驗證碼錯誤訊息。 */
export const getCaptchaErrMsg = (code: string) => {
  switch (code) {
    case 'error.captcha.expired':
      return '驗證碼過期';
    case 'error.captcha.mismatch':
      return '驗證碼錯誤';
    default:
      return '';
  }
};
